import { Spacing } from 'zens-storybook'
import React, { Suspense } from 'react'
import { StyleSheet, View, useWindowDimensions } from 'react-native'
import { useNumberParams } from 'zens-router'
import { LayoutHeader, FloorFloorplan, WorkspaceHeader } from '@dms/component'
import { useTranslation } from 'react-i18next'
import { useWorkspace } from 'zens-store'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  content: {
    margin: Spacing.S,
    padding: Spacing.S,
    flex: 1,
  },
})

const ScreenWorkspaceFloorplanLocation = () => {
  const [{ companyId, workspaceId }] = useNumberParams()
  const { t } = useTranslation()
  const workspace = useWorkspace({ companyId, workspaceId })
  const { height } = useWindowDimensions()
  const contentStyle = { height: height - 130 - 2 * Spacing.M }

  return (
    <View style={styles.container}>
      <Suspense fallback={<LayoutHeader.Skeleton breadcrumb title />}>
        <WorkspaceHeader
          companyId={companyId}
          workspaceId={workspaceId}
          breadcrumbItems={[{ title: t('Floorplan') }]}
          title={(workspace) => t('Location of {{workspace}} on floorplan', { workspace })}
        />
      </Suspense>
      <View style={styles.content}>
        <Suspense fallback={<FloorFloorplan.Skeleton style={contentStyle} />}>
          <FloorFloorplan
            companyId={companyId}
            floorId={workspace.data?.floorId || 0}
            workspaceId={workspaceId}
            style={contentStyle}
          />
        </Suspense>
      </View>
    </View>
  )
}

export default ScreenWorkspaceFloorplanLocation
